import { api } from "@/lib/api";
export const submitRegistration = (data: any) => api.post("/resident/registration", data, {
	headers: {
		"Content-Type": "multipart/form-data",
	}
});

export const getDepartments = async () => {
	const response = await api.get("/departments");
	return response.data;
}
export const getSponsorshipTypes = async () => {
	const response = await api.get("/sponsorship-types");
	return response.data;
}
export const getExistingRegistration = async () => {
	const response = await api.get("/resident/registrations/existing");
	return response.data;
}
